module.exports = __webpack_public_path__ + "static/media/hashtag-nft-13.c224c0bf.jpg";